import React, {useEffect, useState} from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {View, StyleSheet} from "react-native";
import PtText from "../pt-text/pt-text";
import {styleVars} from "../../../app-style-vars";

import "./pt-date-time-picker.css";
import {getTranslation} from "../../../helpers/getTranslation";

export default function PtDateTimePicker(props) {

  const initialDate = props.initialDate ? props.initialDate : null;
  const minDate = props.minDate ? props.minDate : null;
  const maxDate = props.maxDate ? props.maxDate : null;
  const dateFormat = getTranslation('lang.settings.date.format') || 'yyyy-MM-dd';

  const [selectedDate, setSelectedDate] = useState(initialDate)

  useEffect(() => {
    /** we only need to do this if state is maintained on some upper level component and passed down via initialDate prop */
    if(props.dateChangedHandler) {
      setSelectedDate(initialDate);
    }
  });

  const updateSelectedDate = (date:any) => {
    if(props.dateChangedHandler) {
      props.dateChangedHandler({newDate: date})
    } else {
      setSelectedDate(date);
    }
  }

  const ExampleCustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <button className="pt-datepicker-style" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  return (
    <View style={[styles.datePickerContainer]}>
      {props.title ?
        <PtText style={[styles.datePickerLabelText]}>{props.title}</PtText>
        : null
      }
      <DatePicker
        onChange={date => updateSelectedDate(date)}
        dateFormat={dateFormat}
        selected={selectedDate}
        minDate={minDate}
        maxDate={maxDate}
        popperPlacement={'bottom'}
        popperModifiers={{
          flip: { behavior: ['bottom']},
          preventOverflow: { enabled: false },
          hide: { enabled: false}
        }}
        customInput={<ExampleCustomInput />}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  datePickerContainer: {
    paddingVertical: styleVars.rem(.5),
  },
  datePickerLabelText: {
    fontSize: styleVars.rem(.75)
  },
  dateInputStyle: {
    height: 40,
    borderWidth: 0,
    borderColor: styleVars.boschLightGray,
    borderBottomWidth: 1
  }
})